module.exports = __webpack_public_path__ + "media/images/app/become-vendor/strongbox-3-bc1dbf20d0a02eb87c8a8f6ff89d6429.webp";